var Handlebars = require("../../../node_modules/.pnpm/handlebars@4.7.9_patch_hash=53ad8d748fa2ca3a7a0502c46f2ed1236eef8162efec84c06849dc83ad9e28e9/node_modules/handlebars/runtime.js");
function __default(obj) { return obj && (obj.__esModule ? obj["default"] : obj); }
module.exports = (Handlebars["default"] || Handlebars).template({"0":function(container,depth0,helpers,partials,data,blockParams,depths) {
    var stack1, alias1=container.strict, alias2=container.lambda, alias3=container.escapeExpression, lookupProperty = container.lookupProperty || function(parent, propertyName) {
        if (Object.prototype.hasOwnProperty.call(parent, propertyName)) {
          return parent[propertyName];
        }
        return undefined
    };

  return "        <div class=\"check checked sub_unsub_button\">\n\n            <div class=\"tippy-zulip-tooltip\" data-tooltip-template-id=\"unsubscribe-from-"
    + alias3(alias2(alias1(depth0, "stream_id", {"start":{"line":7,"column":90},"end":{"line":7,"column":99}} ), depth0))
    + "-stream-tooltip-template\">\n                <template id=\"unsubscribe-from-"
    + alias3(alias2(alias1(depth0, "stream_id", {"start":{"line":8,"column":49},"end":{"line":8,"column":58}} ), depth0))
    + "-stream-tooltip-template\">\n                    <span>\n"
    + ((stack1 = lookupProperty(helpers,"tr").call(depth0 != null ? depth0 : (container.nullContext || {}),{"name":"tr","hash":{},"fn":container.program(1, data, 0, blockParams, depths),"inverse":container.noop,"data":data,"loc":{"start":{"line":10,"column":24},"end":{"line":13,"column":31}}})) != null ? stack1 : "")
    + "                    </span>\n                </template>\n\n                <i class=\"zulip-icon zulip-icon-subscriber-check sub-unsub-icon\"></i>\n            </div>\n            <div class='sub_unsub_status'></div>\n        </div>\n";
},"1":function(container,depth0,helpers,partials,data,blockParams,depths) {
    var lookupProperty = container.lookupProperty || function(parent, propertyName) {
        if (Object.prototype.hasOwnProperty.call(parent, propertyName)) {
          return parent[propertyName];
        }
        return undefined
    };

  return "                            Unsubscribe from <z-stream></z-stream>\n                            \n";
},"2":function(container,depth0,helpers,partials,data) {
    var stack1;

  return ((stack1 = container.invokePartial(require("../decorated_channel_name.hbs"),undefined,{"name":"../decorated_channel_name","hash":{"stream":depth0,"inline_with_text":true},"data":data,"helpers":helpers,"partials":partials,"decorators":container.decorators})) != null ? stack1 : "");
},"3":function(container,depth0,helpers,partials,data,blockParams,depths) {
    var stack1, alias1=depth0 != null ? depth0 : (container.nullContext || {}), alias2=container.strict, alias3=container.lambda, alias4=container.escapeExpression, lookupProperty = container.lookupProperty || function(parent, propertyName) {
        if (Object.prototype.hasOwnProperty.call(parent, propertyName)) {
          return parent[propertyName];
        }
        return undefined
    };

  return "        <div class=\"check sub_unsub_button "
    + ((stack1 = lookupProperty(helpers,"unless").call(alias1,lookupProperty(depth0,"should_display_subscription_button"),{"name":"unless","hash":{},"fn":container.program(4, data, 0, blockParams, depths),"inverse":container.noop,"data":data,"loc":{"start":{"line":22,"column":43},"end":{"line":22,"column":108}}})) != null ? stack1 : "")
    + "\">\n\n            <div class=\"tippy-zulip-tooltip\"  data-tooltip-template-id=\""
    + ((stack1 = lookupProperty(helpers,"if").call(alias1,lookupProperty(depth0,"should_display_subscription_button"),{"name":"if","hash":{},"fn":container.program(5, data, 0, blockParams, depths),"inverse":container.program(6, data, 0, blockParams, depths),"data":data,"loc":{"start":{"line":24,"column":72},"end":{"line":24,"column":236}}})) != null ? stack1 : "")
    + "\">\n                <template id=\"subscribe-to-"
    + alias4(alias3(alias2(depth0, "stream_id", {"start":{"line":25,"column":45},"end":{"line":25,"column":54}} ), depth0))
    + "-stream-tooltip-template\">\n                    <span>\n"
    + ((stack1 = lookupProperty(helpers,"tr").call(alias1,{"name":"tr","hash":{},"fn":container.program(7, data, 0, blockParams, depths),"inverse":container.noop,"data":data,"loc":{"start":{"line":27,"column":24},"end":{"line":30,"column":31}}})) != null ? stack1 : "")
    + "                    </span>\n                </template>\n\n                <template id=\"cannot-subscribe-to-"
    + alias4(alias3(alias2(depth0, "stream_id", {"start":{"line":34,"column":52},"end":{"line":34,"column":61}} ), depth0))
    + "-stream-tooltip-template\">\n                    <span>\n"
    + ((stack1 = lookupProperty(helpers,"tr").call(alias1,{"name":"tr","hash":{},"fn":container.program(8, data, 0, blockParams, depths),"inverse":container.noop,"data":data,"loc":{"start":{"line":36,"column":24},"end":{"line":39,"column":31}}})) != null ? stack1 : "")
    + "                    </span>\n                </template>\n\n                <i class=\"zulip-icon zulip-icon-subscriber-plus sub-unsub-icon\"></i>\n            </div>\n            <div class='sub_unsub_status'></div>\n        </div>\n";
},"4":function(container,depth0,helpers,partials,data) {
    return "disabled";
},"5":function(container,depth0,helpers,partials,data) {
    return "subscribe-to-"
    + container.escapeExpression(container.lambda(container.strict(depth0, "stream_id", {"start":{"line":24,"column":129},"end":{"line":24,"column":138}} ), depth0))
    + "-stream-tooltip-template";
},"6":function(container,depth0,helpers,partials,data) {
    return "cannot-subscribe-to-"
    + container.escapeExpression(container.lambda(container.strict(depth0, "stream_id", {"start":{"line":24,"column":194},"end":{"line":24,"column":203}} ), depth0))
    + "-stream-tooltip-template";
},"7":function(container,depth0,helpers,partials,data,blockParams,depths) {
    var lookupProperty = container.lookupProperty || function(parent, propertyName) {
        if (Object.prototype.hasOwnProperty.call(parent, propertyName)) {
          return parent[propertyName];
        }
        return undefined
    };

  return "                            Subscribe to <z-stream></z-stream>\n                            \n";
},"8":function(container,depth0,helpers,partials,data,blockParams,depths) {
    var lookupProperty = container.lookupProperty || function(parent, propertyName) {
        if (Object.prototype.hasOwnProperty.call(parent, propertyName)) {
          return parent[propertyName];
        }
        return undefined
    };

  return "                            Cannot subscribe to <z-stream></z-stream>\n                            \n";
},"9":function(container,depth0,helpers,partials,data) {
    var alias1=container.escapeExpression, lookupProperty = container.lookupProperty || function(parent, propertyName) {
        if (Object.prototype.hasOwnProperty.call(parent, propertyName)) {
          return parent[propertyName];
        }
        return undefined
    };

  return "            <div class=\"stream-message-count tippy-zulip-tooltip\" data-tippy-content=\""
    + alias1(lookupProperty(helpers,"t").call(depth0 != null ? depth0 : (container.nullContext || {}),"Estimated messages per week",{"name":"t","hash":{},"data":data,"loc":{"start":{"line":59,"column":86},"end":{"line":59,"column":122}}}))
    + "\">\n                <i class=\"fa fa-bar-chart\"></i>\n                <span class=\"stream-message-count-text\">"
    + alias1(container.lambda(container.strict(depth0, "stream_weekly_traffic", {"start":{"line":61,"column":58},"end":{"line":61,"column":79}} ), depth0))
    + "</span>\n            </div>\n";
},"10":function(container,depth0,helpers,partials,data) {
    var alias1=depth0 != null ? depth0 : (container.nullContext || {}), alias2=container.escapeExpression, lookupProperty = container.lookupProperty || function(parent, propertyName) {
        if (Object.prototype.hasOwnProperty.call(parent, propertyName)) {
          return parent[propertyName];
        }
        return undefined
    };

  return "            <div class=\"stream-message-count tippy-zulip-tooltip\" data-tippy-content=\""
    + alias2(lookupProperty(helpers,"t").call(alias1,"Channel created recently",{"name":"t","hash":{},"data":data,"loc":{"start":{"line":64,"column":86},"end":{"line":64,"column":119}}}))
    + "\">\n                <span class=\"stream-message-count-text\">"
    + alias2(lookupProperty(helpers,"t").call(alias1,"New",{"name":"t","hash":{},"data":data,"loc":{"start":{"line":65,"column":56},"end":{"line":65,"column":68}}}))
    + "</span>\n            </div>\n";
},"compiler":[8,">= 4.3.0"],"main":function(container,depth0,helpers,partials,data,blockParams,depths) {
    var stack1, alias1=container.strict, alias2=container.lambda, alias3=container.escapeExpression, alias4=depth0 != null ? depth0 : (container.nullContext || {}), lookupProperty = container.lookupProperty || function(parent, propertyName) {
        if (Object.prototype.hasOwnProperty.call(parent, propertyName)) {
          return parent[propertyName];
        }
        return undefined
    };

  return "<div class=\"stream-row\" data-stream-id=\""
    + alias3(alias2(alias1(depth0, "stream_id", {"start":{"line":2,"column":42},"end":{"line":2,"column":51}} ), depth0))
    + "\" data-stream-name=\""
    + alias3(alias2(alias1(depth0, "name", {"start":{"line":2,"column":75},"end":{"line":2,"column":79}} ), depth0))
    + "\">\n\n"
    + ((stack1 = lookupProperty(helpers,"if").call(alias4,lookupProperty(depth0,"subscribed"),{"name":"if","hash":{},"fn":container.program(0, data, 0, blockParams, depths),"inverse":container.program(3, data, 0, blockParams, depths),"data":data,"loc":{"start":{"line":4,"column":4},"end":{"line":47,"column":11}}})) != null ? stack1 : "")
    + "    "
    + ((stack1 = container.invokePartial(require("./subscription_setting_icon.hbs"),depth0,{"name":"subscription_setting_icon","data":data,"helpers":helpers,"partials":partials,"decorators":container.decorators})) != null ? stack1 : "")
    + "    <div class=\"sub-info-box\">\n        <div class=\"top-bar\">\n            <div class=\"stream-name\">"
    + alias3(alias2(alias1(depth0, "name", {"start":{"line":51,"column":39},"end":{"line":51,"column":43}} ), depth0))
    + "</div>\n            <div class=\"subscriber-count tippy-zulip-tooltip\" data-tippy-content=\""
    + alias3(lookupProperty(helpers,"t").call(alias4,"Subscriber count",{"name":"t","hash":{},"data":data,"loc":{"start":{"line":52,"column":82},"end":{"line":52,"column":107}}}))
    + "\">\n                "
    + ((stack1 = container.invokePartial(require("./subscriber_count.hbs"),depth0,{"name":"subscriber_count","data":data,"helpers":helpers,"partials":partials,"decorators":container.decorators})) != null ? stack1 : "")
    + "            </div>\n        </div>\n        <div class=\"bottom-bar\">\n            <div class=\"description rendered_markdown\" data-no-description=\""
    + alias3(lookupProperty(helpers,"t").call(alias4,"No description.",{"name":"t","hash":{},"data":data,"loc":{"start":{"line":57,"column":76},"end":{"line":57,"column":99}}}))
    + "\">"
    + alias3(lookupProperty(helpers,"rendered_markdown").call(alias4,lookupProperty(depth0,"rendered_description"),{"name":"rendered_markdown","hash":{},"data":data,"loc":{"start":{"line":57,"column":101},"end":{"line":57,"column":143}}}))
    + "</div>\n"
    + ((stack1 = lookupProperty(helpers,"if").call(alias4,lookupProperty(depth0,"is_old_stream"),{"name":"if","hash":{},"fn":container.program(9, data, 0, blockParams, depths),"inverse":container.program(10, data, 0, blockParams, depths),"data":data,"loc":{"start":{"line":58,"column":12},"end":{"line":67,"column":19}}})) != null ? stack1 : "")
    + "        </div>\n    </div>\n</div>\n";
},"1_d":  function(fn, props, container, depth0, data, blockParams, depths) {

  var decorators = container.decorators, lookupProperty = container.lookupProperty || function(parent, propertyName) {
        if (Object.prototype.hasOwnProperty.call(parent, propertyName)) {
          return parent[propertyName];
        }
        return undefined
    };

  var decorator = lookupProperty(decorators,"inline");
  if (typeof decorator !== "function") { throw new Error("Missing decorator: \"inline\""); }
  fn = decorator(fn,props,container,{"name":"inline","hash":{},"fn":container.program(2, data, 0, blockParams, depths),"inverse":container.noop,"args":["z-stream"],"data":data,"loc":{"start":{"line":12,"column":28},"end":{"line":12,"column":127}}}) || fn;
  return fn;
  }

,"useDecorators":true,"7_d":  function(fn, props, container, depth0, data, blockParams, depths) {

  var decorators = container.decorators, lookupProperty = container.lookupProperty || function(parent, propertyName) {
        if (Object.prototype.hasOwnProperty.call(parent, propertyName)) {
          return parent[propertyName];
        }
        return undefined
    };

  var decorator = lookupProperty(decorators,"inline");
  if (typeof decorator !== "function") { throw new Error("Missing decorator: \"inline\""); }
  fn = decorator(fn,props,container,{"name":"inline","hash":{},"fn":container.program(2, data, 0, blockParams, depths),"inverse":container.noop,"args":["z-stream"],"data":data,"loc":{"start":{"line":29,"column":28},"end":{"line":29,"column":127}}}) || fn;
  return fn;
  }

,"8_d":  function(fn, props, container, depth0, data, blockParams, depths) {

  var decorators = container.decorators, lookupProperty = container.lookupProperty || function(parent, propertyName) {
        if (Object.prototype.hasOwnProperty.call(parent, propertyName)) {
          return parent[propertyName];
        }
        return undefined
    };

  var decorator = lookupProperty(decorators,"inline");
  if (typeof decorator !== "function") { throw new Error("Missing decorator: \"inline\""); }
  fn = decorator(fn,props,container,{"name":"inline","hash":{},"fn":container.program(2, data, 0, blockParams, depths),"inverse":container.noop,"args":["z-stream"],"data":data,"loc":{"start":{"line":38,"column":28},"end":{"line":38,"column":127}}}) || fn;
  return fn;
  }

,"usePartial":true,"useData":true,"useDepths":true});